import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "512",
  height: "512",
  viewBox: "0 0 520 520"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "data-name": "13-Cancel" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#e06565",
    d: "M260 488A228 228 0 0 1 98.78 98.78a228 228 0 1 1 322.44 322.44A226.5 226.5 0 0 1 260 488z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#bf0411",
    d: "M344.671 395.026 342.75 393 260 310.253l-84.713 84.713L125 344.7l84.722-84.723L125 175.252l50.278-50.278L260 209.7l84.723-84.722L395 175.252l-84.722 84.722L395 344.7z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }